import React from "react";
import { useT } from "@/lib/LanguageContext";
import { cn } from "../../../lib/utils";
import { STAGE_KEYS, STAGE_SHORT_KEYS } from "../contract";
import { STATE_CLASSES } from "../theme/states";

const TONES = { lead: STATE_CLASSES.neutral, active: STATE_CLASSES.positive, past: STATE_CLASSES.past };

/**
 * The client's stage in the admin's pill style: Lead (neutral), Active client (sage),
 * Past client (ochre). A manual override renders OUTLINED with a "manual" marker
 * ("Active · manual"), because rules leave that client alone until "Resume automatic".
 *
 * `short` prints the table form ("Active") instead of the full label ("Active client").
 */
export default function StageBadge({ stage, mode = "auto", short = false, className, testId }) {
  const t = useT("crm");
  const key = (short ? STAGE_SHORT_KEYS : STAGE_KEYS)[stage];
  if (!key) return null;
  if (mode === "manual") {
    return (
      <span data-testid={testId} data-stage={stage} data-mode="manual"
        className={cn("inline-flex items-center rounded-full border border-eh-ink px-2.5 py-0.5 text-xs text-eh-ink whitespace-nowrap", className)}>
        {t("stage.manualBadge", { stage: t(STAGE_SHORT_KEYS[stage]) })}
      </span>
    );
  }
  return (
    <span data-testid={testId} data-stage={stage} data-mode="auto"
      className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs whitespace-nowrap", TONES[stage], className)}>
      {t(key)}
    </span>
  );
}
